export const tableColumns =  {
    "pagePathType": {
      "title": "Page Path",
      "key": "pagePathType",
    },
    "ads": {
      "title": "Ads",
      "key": "ads",
    },
    "adVisits": {
      "title": "Ad Visits",
      "key": "adVisits",
    },
    "visitOfAds": {
      "title": "Ad Visits/Ads",
      "key": "visitOfAds",
    }
  };


export const csvColumns = {
    "pagePathType":{
       "title":"Page Path",
       "key":"pagePathType"
    },
    "adVisits":{
       "title":"Ad Visits",
       "key":"adVisits"
    },
    "adVisitsRate":{
       "title":"Ad Visits Percentage",
       "key":"adVisitsRate"
    },
    "ads":{
       "title":"Ads",
       "key":"ads"
    },
    "visitOfAds":{
       "title":"Ad Visits/Ads",
       "key":"visitOfAds"
    }
 };

export const INIT_NEW_AD_USERS_PER_AD_SORT = {
    sortKey: 'newAdUsersOfAds',
    sortType: 'desc'
};

export const INIT_NEW_AD_USERS_SORT = {
    sortKey: 'newAdUsers',
    sortType: 'desc'
};

export const INIT_AD_VISITS_SORT = {
  sortKey: 'adVisits',
  sortType: 'desc'
};
